import React from 'react';
import styled from '@emotion/styled';

export default class Cell extends React.Component {
  componentDidMount() {
    this.props.cellMounted(true);
  }

  render() {
    const {
      item, gap, render, cellWidth, cellMounted, ...props
    } = this.props;

    return (
      <div {...props} className="cell">
        {render({
          item,
          gap,
          cellWidth,
        })}
      </div>
    );
  }
}
